/**
 * イベント (グループ) の設定。
 *
 * 名前と通貨は最初に決めたら滅多に変えないので、タブを 1 つ占有させず、
 * イベント名の隣から開く折りたたみにしている。
 *
 * 精算の方針はここでは持たない。送金プランを見ながら切り替えるものなので、
 * 「精算」タブに置いている (グループの既定値としては触らせない)。
 * カードの中に差し込む前提なので、ここでは <section> を持たない。
 */
import { useUpdateGroup } from "@spli/app-logic";
import { CURRENCY_CODES, getCurrency, type CurrencyCode, type GroupDto } from "@spli/core";
import { useState, type FormEvent } from "react";
import { ErrorView } from "../../components/StatusViews.js";

export interface GroupSettingsProps {
  group: GroupDto;
  /** 保存が成功したら閉じる */
  onSaved?: () => void;
  onCancel?: () => void;
}

export function GroupSettings({ group, onSaved, onCancel }: GroupSettingsProps) {
  const updateGroup = useUpdateGroup(group.shareToken);
  const [name, setName] = useState(group.name);
  const [currency, setCurrency] = useState<CurrencyCode>(group.currency);

  const handleSubmit = (event: FormEvent): void => {
    event.preventDefault();
    if (name.trim() === "") return;
    updateGroup.mutate({ name: name.trim(), currency }, { onSuccess: () => onSaved?.() });
  };

  return (
    <form className="group-settings" onSubmit={handleSubmit} noValidate>
      <div className="field">
        <label className="field__label" htmlFor="settings-name">
          イベント名
        </label>
        <input
          id="settings-name"
          className="input"
          value={name}
          onChange={(event) => setName(event.target.value)}
        />
      </div>

      <div className="field">
        <label className="field__label" htmlFor="settings-currency">
          通貨
        </label>
        <select
          id="settings-currency"
          className="select"
          value={currency}
          onChange={(event) => setCurrency(event.target.value as CurrencyCode)}
        >
          {CURRENCY_CODES.map((code) => (
            <option key={code} value={code}>
              {getCurrency(code).label} ({getCurrency(code).symbol})
            </option>
          ))}
        </select>
      </div>

      {updateGroup.isError && <ErrorView error={updateGroup.error} />}

      <div className="row row--end">
        {onCancel && (
          <button type="button" className="button button--secondary button--small" onClick={onCancel}>
            キャンセル
          </button>
        )}
        <button
          type="submit"
          className="button button--small"
          disabled={updateGroup.isPending || name.trim() === ""}
        >
          {updateGroup.isPending ? "保存中…" : "保存する"}
        </button>
      </div>
    </form>
  );
}
